import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, } from "@angular/common/http";
import { EMPTY, Observable, throwError } from "rxjs";
import { Router } from "@angular/router";
import { UnauthorizePromptService } from "../unauthorize-prompt/unauthorize-prompt.service";
import { catchError } from "rxjs/operators";
import { TranslocoService } from "@ngneat/transloco";
import { isNewErrorSchema } from "src/app/shared/utils/is-new-error-schema";
import { ErrorHandlerService } from "src/app/services/error-handler.service";
import { MatDialog } from "@angular/material/dialog";
import { ConfigService } from "../../config/config.service";
import { ThemeNames } from "src/app/appsettings";
import { UnauthorizedV2Component } from "src/app/shared/components/unauthorized-v2/unauthorized-v2.component";
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private session = [];
  constructor(
    private readonly dialog: MatDialog,
    private readonly config: ConfigService,
    private router: Router,
    private notAuth: UnauthorizePromptService,
    private transloco: TranslocoService,
    private readonly errorHandlerService: ErrorHandlerService,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const isBluePulseTheme = this.config._envConfig?.ThemeName === ThemeNames.BluePulse;

    this.session = Object.keys(sessionStorage);
    let user = null;
    let tokenJson = null;

    if (this.session.length) {
      user = this.session.find(function (key) {
        return key.includes("oidc.user:");
      });
    }


    if (user) tokenJson = JSON.parse(sessionStorage.getItem(user));

    const token: string = tokenJson ? `${tokenJson.token_type} ${tokenJson.access_token}` : "";
    request = request.clone({
      setHeaders: {
        Authorization: token,
        "Accept-Language": this.getActiveLanguage()
      },
    });

    return next.handle(request).pipe(
      catchError((error) => {
        const isSigninCallback = this.router.routerState.snapshot.url.includes('signin-callback');
        const isSharedResult = this.router.routerState.snapshot.url.includes('results/shared-result');

        if (isNewErrorSchema(error.error) && !isSigninCallback && !isSharedResult) {
          this.errorHandlerService.handleError(error);
          return EMPTY;
        } else if ((error.status === 401 || error.status === 403) && !isSigninCallback && !isSharedResult) {
          if (isBluePulseTheme) {
            const opts = {
              disableClose: true,
              width: '450px', 
              maxWidth: '100vw', 
              panelClass: 'blue-pulse-dialog',
            }
            setTimeout(() => {
              this.dialog.closeAll();
              this.dialog.open(UnauthorizedV2Component, opts);
            }, 1050);
            
            return;
          }

          this.notAuth.showPopup()
        }

        return throwError(error);
      })
    );
  }

  private getActiveLanguage(): string{
    let activeLang = this.transloco.getActiveLang().toLowerCase();
    let language = activeLang;

    switch (activeLang) {
      case 'et': language = 'et-EE'; break;
      case 'ru': language = 'ru-RU'; break;
      case 'en':
      case 'en-us':
      case 'en-gb': language = 'en-GB'; break;
    }
    return language;
  }
}
